import { render, staticRenderFns } from "./ajFormBase.vue?vue&type=template&id=8fc5954e&scoped=true"
import script from "./ajFormBase.vue?vue&type=script&lang=js"
export * from "./ajFormBase.vue?vue&type=script&lang=js"
import style0 from "./ajFormBase.vue?vue&type=style&index=0&id=8fc5954e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc5954e",
  null
  
)

export default component.exports